export default __webpack_public_path__ + "static/media/person.9155cc16.svg";